import { baseApi } from './baseApi'

import {
  PatientTransactionsList,
  PatientTransactionsListQuery,
  PatientAging,
  PatientAgingQuery,
  PatientBalances,
  PatientBalancesQuery,
} from 'store/types'

export const patientTransactionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatientTransactions: builder.query<PatientTransactionsList, PatientTransactionsListQuery>({
      query: ({ patientId, ...query }) => ({ url: `/lab/patients/${patientId}/account/transactions`, params: query }),
      providesTags: (result, error, { patientId }) => [{ type: 'Patient', id: Number(patientId) }],
    }),
    getPatientAging: builder.query<PatientAging, PatientAgingQuery>({
      query: ({ patientId }) => ({ url: `/lab/patients/${patientId}/account/aging` }),
      providesTags: (result, error, { patientId }) => [{ type: 'Patient', id: Number(patientId) }],
    }),
    getPatientBalances: builder.query<PatientBalances, PatientBalancesQuery>({
      query: ({ patientId }) => ({ url: `/lab/patients/${patientId}/account/balances` }),
      providesTags: (result, error, { patientId }) => [{ type: 'Patient', id: Number(patientId) }],
    }),
  }),
})

export const {
  useGetPatientTransactionsQuery,
  useGetPatientAgingQuery,
  useGetPatientBalancesQuery,
} = patientTransactionsApi



